import { createFileRoute } from "@tanstack/react-router";

import { BaseEditCreateModal } from "@/components/_Modals/BaseEditCreateModal";
import { ProfileForm } from "@/features/dashboard/perfil/components/ProfileForm";

export const Route = createFileRoute("/_private/dashboard/_base/perfil/modal")({
  component: () => (
    <BaseEditCreateModal title="Editar Perfil" from="/dashboard/perfil">
      <ProfileForm />
    </BaseEditCreateModal>
  )
});
